<script>
import EntitySelectInput from '@/components/form/Inputs/EntitySelectInput'
import FilterOptionList from './FilterOptionList'
import filter from './filter'

export default {
    components: { EntitySelectInput, FilterOptionList },

    mixins: [filter],

    props: {
        useNameField: {
            type: Boolean,
        },
        useIdField: {
            type: Boolean,
        },
        // the options as a checkbox list, inside a filter pill menu (tasks#211)
        list: {
            type: Boolean,
        },
    },
}
</script>

<template>
    <filter-option-list
        v-if="list"
        :value="internalValue"
        :entity="field.entity"
        :translate="field.translate"
        :multiple="field.multiple"
        :use-name-field="field.useNameField"
        :use-id-field="useIdField"
        :query-params="field.queryParams"
        :items-filter="field.itemsFilter"
        :disabled="blocked"
        @input="setValue"
    ></filter-option-list>
    <entity-select-input
        v-else
        :value="internalValue"
        :label="field.label"
        :entity="field.entity"
        :translate-items="field.translate"
        :use-name-field="field.useNameField"
        :use-id-field="useIdField"
        :disabled="blocked"
        :multi-select="field.multiple"
        :query-params="field.queryParams"
        :items-filter="field.itemsFilter"
        hide-details="auto"
        autocomplete
        filter
        @input="setValue"
    ></entity-select-input>
</template>
